import styled, { css } from 'styled-components';

export const TabContainer = styled.div`
  ${({}) => {
    return css`
      width: -webkit-fill-available;
    `;
  }}
`;

export const TabTags = styled.div`
  display: flex;
  align-items: center;
`;

export const TabControl = styled.input.attrs({ type: 'radio', name: 'tabs' })`
  ${({}) => {
    return css`
      &[type='radio'] {
        display: none;
      }
      &:checked + label {
        background: white;
        margin-bottom: 0;
        border-bottom-left-radius: 0;
        border-bottom-right-radius: 0;
        color: #364856;
        border-top: none;
      }
    `;
  }}
`;

export const Label = styled.label`
  ${({}) => {
    return css`
      display: flex;
      border-top-right-radius: 5px;
      border-top-left-radius: 5px;
      cursor: pointer;
      margin-left: 0px;
      background: #11465d;
      color: white;
      border-bottom: none;
      font-weight: 500;
      font-size: 17px;
      text-align: center;
      align-items: center;
      justify-content: center;
      padding: 1rem 2rem;
    `;
  }}
`;

export const ItemsContainer = styled.div<any>`
  ${({ $selectedTab, minHeight, maxHeight }) => {
    return css`
      width: 100%;
      margin-left: 0px;
      background: #fff;
      border-radius: 5px;
      border-top-left-radius: ${$selectedTab === 0 ? 0 : 10}px;
      max-height: ${maxHeight};
      min-height: ${minHeight};
      overflow: auto;
      border-top: none;
    `;
  }}
`;

export const ItemChildren = styled.div<any>`
  ${({}) => {
    return css`
      width: 100%;
      margin-left: 0px;
    `;
  }}
`;

export const TabsHeader = styled.div<any>`
  ${({}) => {
    return css`
      display: flex;
      margin-left: 0px;
      gap: 6px;
    `;
  }}
`;
